import React from 'react';
import { getToken } from '@/utils/authentication';
import { Select } from 'vkit/lib/components';

interface SelectUserProps {
  small?: boolean;
  label?: string;
  disabled?: boolean;
  fixedList?: boolean;
  placeholder?: string;
  requestParams?: { [key: string]: string };
  selectedUserId?: string;
  onChangeSelectedUser: (...item: any) => void;
}

const SelectUser: React.FC<SelectUserProps> = ({
  small,
  label,
  disabled,
  fixedList = true,
  placeholder = 'Selecione um usuário',
  requestParams,
  selectedUserId,
  onChangeSelectedUser,
}) => {
  return (
    <Select
      small={small}
      clearable
      fixedList={fixedList}
      autoRequest
      searchable
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      value={selectedUserId || ''}
      requestPageParam='page'
      requestParams={requestParams}
      requestResponseRootPath='data'
      requestResponseText='name'
      requestResponseValue='id'
      requestRouter='/users'
      requestSearchParam='q'
      requestUri={process.env.REACT_APP_API_AUTH_URL}
      requestHeaders={{ authorization: `Bearer ${getToken()}` }}
      onChange={onChangeSelectedUser}
    />
  );
};

export default SelectUser;
